import { render, staticRenderFns } from "./services.vue?vue&type=template&id=0bf925aa&scoped=true"
import script from "./services.vue?vue&type=script&lang=js"
export * from "./services.vue?vue&type=script&lang=js"
import style0 from "./services.vue?vue&type=style&index=0&id=0bf925aa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf925aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/luxury_dreams_production/releases/20261103171319/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bf925aa')) {
      api.createRecord('0bf925aa', component.options)
    } else {
      api.reload('0bf925aa', component.options)
    }
    module.hot.accept("./services.vue?vue&type=template&id=0bf925aa&scoped=true", function () {
      api.rerender('0bf925aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/booking/services.vue"
export default component.exports